define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/util",
	"csi/xml"
], function(def,Action,ActionFactory,util,xml) {

	return ActionFactory.declare("Move", Action, {
		// summary: move a node from current parent node (optional) to a child of a new parent node (required)
		//
		// Parameters for request:
		// 	URL - node to be moved
		//  ParentURL - old parent
		//  ParentAttr - relation id from old parent to node
		//  ToURL - new parent
		//  ToAttr - relation id from parent to node to be moved

		constructor: function(obj) {
			this.m_tag = this.m_tag || "Move";
			this.m_idRelation = util.getProperty(obj, "RelationId");	// optional - if same as before, then not required
			this.setBaseRights(xml.RIGHT_WRITE, xml.RIGHT_WRITE);
			if (!this.m_typeControl) {
				this.m_typeControl = def.ACTION_ICON;
				this.m_class = "iconMove " + (this.m_class || "");
			}
		}
	});
});